export default __webpack_public_path__ + "static/croppedvalues-ab24be5c02330ca41a09182faeff8818.png";